module.exports = { "default": require("core-js/library/fn/object/get-own-property-descriptor"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-runtime/core-js/object/get-own-property-descriptor.js
// module id = 186
// module chunks = 0 1


// WEBPACK FOOTER //
// webpack:///node_modules/babel-runtime/core-js/object/get-own-property-descriptor.js